/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Fw_Kits_MoreInputs */

const en_fw_kits_more = /** @type {(inputs: Fw_Kits_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show all ${i?.n}`)
};

const id_fw_kits_more = /** @type {(inputs: Fw_Kits_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tampilkan semua ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Show all {n}" |
*
* @param {Fw_Kits_MoreInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_kits_more = /** @type {((inputs: Fw_Kits_MoreInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Kits_MoreInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_kits_more(inputs)
	return en_fw_kits_more(inputs)
});